import { useContext } from 'react';

import type { FormatterWithPrecision } from '../../core/types/formatter.js';
import { HistogramXFormatterContext } from '../contexts/HistogramXFormatter.context.js';

export const useHistogramXFormatter = () =>
  useContext(HistogramXFormatterContext) as FormatterWithPrecision;
